export default {
      id: "deco_agenda-usage",
      viewBox: "0 0 155 145",
      url: "../dist/images/" + "sprite.svg#deco_agenda-usage",
      toString: function () {
        return this.url;
      }
    }